<template>
  <div id="cupomVenda" :class="{'d-none': !showCupom}">
    <div v-if="comanda" style="font-family: sans-serif">
      <div style="text-align: center">
        <div v-if="comanda.empresa && !showCupom">
          <b class="h5 font-weight-bold m-0">{{comanda.empresa.nome_fantasia}}</b>
          <div v-if="comanda.empresa.cnpj && comanda.empresa.telefone">
            {{ comanda.empresa.cnpj | cpf_cnpj }} | {{ comanda.empresa.telefone | phone }}
          </div>
          <div>
            {{comanda.empresa.endereco}}, {{comanda.empresa.numero}}, {{comanda.empresa.bairro}}, {{empresa.nome_cidade}} - {{empresa.sigla_estado}}
          </div>
          <hr>
        </div>
        <div>#{{ comanda.id_contador }} | {{comanda.data_comanda}} | {{comanda | tipo_comanda }}</div>
        <div>Atendente: {{comanda.atendente}}</div>
        <hr>
        <b>NÃO FISCAL</b>
      </div>
      <div v-if="comanda.cliente">
        <hr>
        <b>CLIENTE:</b> {{comanda.cliente.nome_cliente}}
        <div v-if="comanda.cliente.endereco">
          {{comanda.cliente.endereco}}, {{comanda.cliente.numero}}, {{comanda.cliente.bairro}}
        </div>
        <div v-if="comanda.cliente.telefone"><b>Telefone: </b>{{comanda.cliente.telefone | phone }}</div>
        <div v-if="comanda.cliente.cpf_cnpj">
          <b>{{ comanda.cliente.cpf_cnpj.length <= 11 ? 'CPF' : 'CNPJ' }}: </b> {{comanda.cliente.cpf_cnpj | cpf_cnpj }}
        </div>
      </div>
      <hr>
      <div>
        <b class="h6 m-0 font-weight-bold">PRODUTOS</b>
        <div v-for="p in produtos">
          <b class="right">{{p.total | valor}}</b>
          <div style="margin-top: 4px">
            <b v-if="p.id_medida === '2'">{{p.quantidade + 'kg '}}</b>
            <b v-else>{{p.quantidade | qtd}}x </b>
            <b v-if="p.diversos">{{p.observacao || 'Diversos'}}</b>
            <b v-else>{{p.nome_produto}}</b>
            <div v-for="d in p.divisoes"># {{d.nome_produto}}</div>
            <div v-for="a in p.adicionais">
              + {{(a.quantidade / p.quantidade) | qtdAdc}} {{a.nome_produto}}<span v-if="a.valor > 0">: {{a.valor * a.quantidade | valor}}</span>
            </div>
            <div v-if="p.observacao && !p.diversos">Obs: {{p.observacao}}</div>
          </div>
        </div>
      </div>
      <hr>
      <div v-if="comanda.pagamentos.length">
        <b class="h6 m-0 font-weight-bold">PAGAMENTOS</b>
        <div v-for="p in comanda.pagamentos">
          <div class="right">{{p.valor | valor}}</div>
          <div>
            <div>{{p.nome_pagamento}}</div>
            <div>{{p.observacao}}</div>
          </div>
        </div>
        <hr>
      </div>
      <div>
        <b class="h6 m-0 font-weight-bold">VALORES</b>
        <div>
          <div class="right">{{totalProduto | valor}}</div>
          <div>Produtos</div>
        </div>
        <div v-if="comanda.desconto > 0">
          <div class="right">{{comanda.desconto | valor}}</div>
          <div>Desconto</div>
        </div>
        <div v-if="comanda.frete > 0">
          <div class="right">{{comanda.frete | valor}}</div>
          <div>Taxa de Entrega</div>
        </div>
        <div v-if="taxa_servico > 0">
          <div class="right">{{taxa_servico | valor}}</div>
          <div>{{ impostoNfe ? 'Imposto NF-e' : 'Taxa de Serviço' }}</div>
        </div>
        <div v-if="comanda.cover > 0">
          <div class="right">{{comanda.cover | valor}}</div>
          <div>Couvert</div>
        </div>
        <div v-if="comanda.qtd_pessoas > 1">
          <div class="right">{{(totalPagar / parseInt(comanda.qtd_pessoas || '1')) | valor}}</div>
          <div>Por Pessoa ({{comanda.qtd_pessoas}})</div>
        </div>
        <div v-if="comanda.troco > 0">
          <div class="right">{{comanda.troco | valor}}</div>
          Troco
        </div>
        <div v-if="totalPagar > 0">
          <b class="right">{{totalPagar | valor}}</b>
          <b class="font-weight-bold">Total</b>
        </div>
        <div v-if="comanda.pagamentos.length && totalRecebido < totalPagar">
          <div class="right">{{(totalPagar - totalRecebido) | valor}}</div>
          <div>Restante</div>
        </div>
      </div>
      <div style="text-align: center" v-if="comanda.tipo_comanda === '5'">
        <hr>
        SENHA: {{senha}}
      </div>
      <hr>
      <div style="text-align: center">
        <div style="margin-bottom: 10px" v-if="comanda.observacao">
          <b>OBSERVAÇÃO:</b> <span v-if="comanda.observacao">{{comanda.observacao}}</span>
        </div>
        Automatizado por LeCard<br>www.lecard.delivery
      </div>
      <div class="border-top-cupom" v-if="totalDebitos > 0 || totalCreditos > 0">
        <div style="margin-bottom: 4px">ASSINATURA DO CLIENTE</div>
        <div class="small" v-if="totalDebitos > 0">
          Reconheço a dívida no valor de {{ totalDebitos | valor }} e pagarei até a data de vencimento, podendo em eventuais atrasos acarretar juros e multa.
        </div>
        <div class="small" v-else>
          Confirmo que resgastei o crédito no valor de {{ totalCreditos | valor }}
        </div>
      </div>
    </div>
    <component is="style">
      .right { float: right }
      hr {
        border-top: 1px solid #000;
        margin: 10px 0;
      }
      .border-top-cupom {
        border-top: 2px solid!important;
        padding-top: 4px;
        margin: 42px 0 8px;
        text-align: center
      }
    </component>
  </div>
</template>

<script>
  export default {
    name: "Cupom",
    props: ['showCupom'],
    data() {
      return {
        comanda: null,
        totalProduto: 0,
        taxa_servico: 0,
        totalRecebido: 0,
        totalDebitos: 0,
        totalCreditos: 0,
        totalPagar: 0,
        senha: null,
        produtos: [],
        impostoNfe: false
      }
    },

    methods: {
      toggleTaxaServico() {
        if (['2','4'].includes(this.comanda.tipo_comanda)) {
          return;
        }

        this.taxa_servico = this.servico > 0 ? (this.totalProduto * this.servico / 100) : 0;
      },

      getTotalProduto() {
        let total = 0;
        this.comanda.itens.forEach((obj) => {
          total += parseFloat(obj.valor_total);
        });

        return parseFloat(total.toFixed(2));
      },

      processarDados(dados, total, callback) {
        this.comanda = JSON.parse(JSON.stringify(dados));
        this.totalProduto = total === null ? this.getTotalProduto(total) : total;
        this.totalRecebido = 0;
        this.totalDebitos = 0;
        this.totalCreditos = 0;
        this.taxa_servico = 0;
        this.produtos = [];
        this.senha = this.comanda.id_contador || this.comanda.id_comanda;

        if (this.comanda.status === '1') {
          this.toggleTaxaServico();

        } else {
          this.taxa_servico = this.comanda.taxa_servico
        }

        if (this.comanda.pagamentos.length) {
          this.comanda.pagamentos.forEach(p => {
            this.totalRecebido += parseFloat(p.valor);
            this.totalDebitos += (p.id_pagamento === '2' ? parseFloat(p.valor) : 0);
            this.totalCreditos += (p.id_pagamento === '34' ? parseFloat(p.valor) : 0);
          });
        }

        // agrupar_itens_cupom: true
        const agrupar = true;

        if (!agrupar) {
          this.comanda.itens.forEach(p => {
            let qtd = parseFloat(p.quantidade);
            let nome = p.produto.nome_produto;
            this.produtos.push({
              nome_produto: nome,
              id_medida: p.produto.id_medida,
              quantidade: qtd,
              divisoes: p.divisoes || [],
              adicionais: p.adicionais || [],
              total: p.valor_total,
              diversos: (nome === 'Diversos'),
              observacao: p.observacao || null
            });
          });

        } else {
          const mapa = {};

          this.comanda.itens.forEach((p, index) => {
            const naoAgrupar = (p.adicionais?.length || p.divisoes?.length) || p.produto.id_medida === '2';
            const chave = naoAgrupar ? `item_unico_${index}` : [p.produto.id_tabela_preco, p.observacao || ''].join('|');

            if (!mapa[chave]) {
              mapa[chave] = {
                nome_produto: p.produto.nome_produto,
                id_medida: p.produto.id_medida,
                quantidade: 0,
                total: 0,
                adicionais: p.adicionais || [],
                divisoes: p.divisoes || [],
                observacao: p.observacao || null
              };
            }

            mapa[chave].quantidade += Number(p.quantidade);
            mapa[chave].total += Number(p.valor_total);
          });

          this.produtos = Object.values(mapa).map(p => ({
            ...p, total: Number(p.total.toFixed(2))
          }));
        }

        let couvert = parseFloat(this.comanda.cover || '0');

        if (this.comanda.status === '1' && couvert <= 0 && this.cover && this.comanda.qtd_pessoas) {
          couvert = (this.cover * this.comanda.qtd_pessoas);
          this.comanda.cover = couvert;
        }

        const frete = this.comanda.frete || '0';
        const totalPagar = this.totalProduto - parseFloat(this.comanda.desconto) + parseFloat(this.taxa_servico) + couvert + parseFloat(frete);
        this.totalPagar = parseFloat(totalPagar.toFixed(2));

        if (this.comanda.tipo_comanda === '5') {
          this.senha = this.senha.slice(-2);
        }

        this.$nextTick(() => {
          if (callback) callback();
        });
      }
    },

    mounted() {
      this.impostoNfe = this.$store.state.pdv.json_config.imposto_nfe === '1';
    },

    computed: {
      empresa() {
        return this.$store.state.dataUser
      },

      servico() {
        return this.$store.state.pdv.taxa_servico
      },

      cover() {
        return this.$store.state.pdv.cover
      }
    },

    filters: {
      qtd(value) {
        if (value !== null || value !== undefined) {
          return parseFloat(value).toFixed();
        }
      },

      qtdAdc(value) {
        let qtd = parseFloat(value && !isNaN(value) ? value : '1');
        return qtd > 1 ? (qtd.toFixed() + 'x') : '';
      },

      cpf_cnpj(value) {
        value = typeof value === 'string' ? value.replace(/\D/g, '') : null;

        if (value && !isNaN(value)) {
          if (value.length <= 11) {
            let x = value.match(/(\d{0,3})(\d{0,3})(\d{0,3})(\d{0,2})/);
            return !x[2] ? x[1] : x[1] + '.' + x[2] + '.' + x[3] + (x[4] ? '-' + x[4] : '');
          }

          if (value.length > 11) {
            let x = value.match(/(\d{0,2})(\d{0,3})(\d{0,3})(\d{0,4})(\d{0,2})/);
            return !x[2] ? x[1] : x[1] + '.' + x[2] + '.' + x[3] + '/' + x[4] + (x[5] ? '-' + x[5] : '');
          }
        }
      },

      tipo_comanda(comanda) {
        if (comanda) {
          switch (parseInt(comanda.tipo_comanda)) {
            case 1:
              return "Mesa: " + comanda.mesa;

            case 2:
              return "Delivery";

            case 3:
              return "Comanda: " + comanda.ref_comanda;

            case 4:
              return "Venda Rápida";

            case 5:
              return "Balcão";
          }
        }
      }
    }
  }
</script>
